module.exports = __webpack_public_path__ + "img/popularity-unchecked-ar.f299364c.png";